import styled from "styled-components";
import CardHeader from "../CardHeader/CardHeader";
import CustomTextBox from "../CustomTextBox/CustomTextBox";
import { emailRegex, phoneNo } from "../../Regex";
import Tooltip from "../Base/Tooltip";
import { useState } from "react";

const BodyWrapper = styled.div`
  text-align: left;

  .inputBoxSection {
    margin-top: 7%;
  }

  .disclaimer {
    width: 100%;
    text-align: right;
    margin-top: 1%;
    cursor: pointer;
    display: flex;

    .checkBoxContainer {
      width: 50%;
      text-align: left;
    }

    .checkBoxText {
      margin-left: 10px;
    }

    .disclaimerContainer {
      width: 50%;
      text-align: right;
      text-decoration: underline;
    }

    @media (max-width: 480px) {
      display: block;

      .checkBoxContainer {
        width: 100%;
        text-align: left;
        margin-top: 10px;
      }

      .disclaimerContainer {
        width: 100%;
        text-align: left;
        text-decoration: underline;
        margin-top: 10px;
      }
    }
  }
`;

const AccountDetailsForm = ({
  handleCustomTextBoxOnBlur,
  handleCustomTextBoxKeyPress,
  handleAgreementClick,
  phoneNoAgree,
}) => {
  const [isRepeteadMail, setIsRepeteadMail] = useState(false);

  return (
    <BodyWrapper>
      <CardHeader text={"Account Details"} />
      <div className="inputBoxSection">
        <CustomTextBox
          placeholder="Recovery Email"
          errorMessage={
            isRepeteadMail
              ? "Cannot be the same email you signed up with"
              : "Enter a valid email"
          }
          name="secondEmail"
          regexCode={emailRegex}
          onBlur={handleCustomTextBoxOnBlur}
          onKeyPress={handleCustomTextBoxKeyPress}
          setIsRepeteadMail={setIsRepeteadMail}
          isRepeteadMail={isRepeteadMail}
        />
      </div>
      <div className="inputBoxSection">
        <CustomTextBox
          placeholder="First Name"
          errorMessage="Not a valid name"
          name="firstName"
          onBlur={handleCustomTextBoxOnBlur}
          onKeyPress={handleCustomTextBoxKeyPress}
        />
      </div>
      <div className="inputBoxSection">
        <CustomTextBox
          placeholder="Last Name"
          errorMessage="Not a valid name"
          name="lastName"
          onBlur={handleCustomTextBoxOnBlur}
          onKeyPress={handleCustomTextBoxKeyPress}
        />
      </div>
      <div className="inputBoxSection">
        <CustomTextBox
          placeholder="What your friends call you"
          errorMessage="Not a valid name"
          name="nickName"
          onBlur={handleCustomTextBoxOnBlur}
          onKeyPress={handleCustomTextBoxKeyPress}
        />
      </div>
      <div className="inputBoxSection">
        <CustomTextBox
          placeholder="Mobile Phone"
          errorMessage="Phone number should be 10 digits"
          name="phoneNo"
          regexCode={phoneNo}
          onBlur={handleCustomTextBoxOnBlur}
          onKeyPress={handleCustomTextBoxKeyPress}
        />
      </div>
      <div className="disclaimer">
        <div className="checkBoxContainer">
          <input
            type="checkbox"
            className="checkBox"
            value="By checking this box, I verify this is my number and consent to receive text messages via automated technology to this number in order to verify and access my account. Message and data rates may apply."
            name="agree"
            checked={phoneNoAgree}
            onClick={handleAgreementClick}
          ></input>
          <span className="checkBoxText">
            By checking this box, I verify this is my number and consent to
            receive text messages via automated technology to this number in
            order to verify and access my account. Message and data rates may
            apply.
          </span>
        </div>
        <div className="disclaimerContainer">
          Phone disclaimer
          <Tooltip
            className={`${window.screen.width > 480 ? "right" : "left"}`}
            text="You are consenting to be contacted at this phone number for account verification and marketing purposes from Tactive. Wireless and text message fees from your carrier may apply. Your phone number will only be used consistent with our Privacy Policy."
          />
        </div>
      </div>
    </BodyWrapper>
  );
};

export default AccountDetailsForm;
